export default "__VITE_ASSET__IxTfTLPK__"